var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EditIcon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M12 2.91879C11.8901 2.91879 11.7848 2.96243 11.7071 3.04011L11.7071 3.04015L3.56992 11.1763L3.37425 11.9587L4.15595 11.7638L12.2929 3.62594L12.2929 3.62589C12.3706 3.54821 12.4142 3.44286 12.4142 3.333C12.4142 3.22314 12.3706 3.11779 12.2929 3.04011C12.2152 2.96243 12.1099 2.91879 12 2.91879ZM10.2929 1.62585C10.7457 1.17312 11.3597 0.918786 12 0.918786C12.6403 0.918786 13.2544 1.17314 13.7071 1.62589C14.1599 2.07865 14.4142 2.69271 14.4142 3.333C14.4142 3.97327 14.1599 4.58731 13.7071 5.04006C13.7071 5.04008 13.7071 5.04009 13.7071 5.04011L5.37415 13.3741C5.24584 13.5024 5.08502 13.5934 4.90894 13.6373L2.24194 14.3023C1.9012 14.3873 1.54087 14.2873 1.29264 14.0389C1.04442 13.7905 0.944678 13.4301 1.02988 13.0894L1.69688 10.4224C1.74085 10.2466 1.83178 10.086 1.95994 9.95785L10.2929 1.62589C10.2929 1.62588 10.2929 1.62586 10.2929 1.62585ZM7 13C7 12.4477 7.44772 12 8 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H8C7.44772 14 7 13.5523 7 13Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#707885"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskEdit);
export default __webpack_public_path__ + "static/media/task-edit.5b7d9707a4a26866a4b0e2f5d0928771.svg";
export { ForwardRef as ReactComponent };